module.exports = __webpack_public_path__ + "static/assets/8b19555004f40ebd9677c44da642a4ad.gif";